import script from "./VolunteerStatsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VolunteerStatsModal.vue?vue&type=script&setup=true&lang=js"

import "./VolunteerStatsModal.vue?vue&type=style&index=0&id=13fa2c1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13fa2c1a"]])

export default __exports__